import * as React from 'react'
import historyStore from '../../../store/historyStore.ts'
import useDayHistoryStore from '../../../store/dayHistoryStore.ts'
import controlStore from '../../../store/controlStore.ts'
import dataStore from '../../../store/dataStore.ts'
import { deviceFromPet } from '../../../helpers/dataHelpers.ts'
import { fetchDayHistory } from '../../../helpers/dayHistoryHelper.ts'
import { DateTime } from 'luxon'
import authStore from '../../../store/authStore.ts'

export const HistoryToggles: React.FC = () => {
    const showSafeZones = historyStore(s => s.showSafeZones)
    const includeInvalid = historyStore(s => s.includeInvalid)
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const dayHistoryActive = useDayHistoryStore(s => s.active)
    const dayHistoryLoading = useDayHistoryStore(s => s.loading)

    const paddingTop = isMobile ? 'pt-[3px]' : 'pt-[5px]'

    const toggleDayHistory = async () => {
        const store = useDayHistoryStore.getState()

        if (store.active) {
            // Exit day history mode
            store.reset()
            return
        }

        // Enter day history mode
        const selectedPetId = historyStore.getState().selectedPetId
        if (!selectedPetId) return

        const pets = dataStore.getState().pets
        const pet = pets.find(p => p._id === selectedPetId)
        if (!pet) return

        const device = deviceFromPet(pet)
        if (!device) return

        store.setActive(true)
        store.setLoading(true)

        // Use today in the user's timezone as the starting point for Day History.
        // We don't use historyStore.endDate because it's in the browser's local timezone
        // and zone-converting it can shift to the wrong calendar day.
        const tz = authStore.getState().effectiveTimezone()
        const zone = tz.value
        const date = DateTime.now().setZone(zone)

        store.setSelectedDate(date)
        const data = await fetchDayHistory(device.iccid, pet._id, date)

        if (data) {
            store.setPathData(data)
            store.setError('')
        } else {
            store.setError('Failed to load day history')
        }
        store.setLoading(false)
    }

    return (
        <div className={'flex items-center gap-2'}>
            {!isMobile && (
                <button
                    className={`btn btn-xs ${dayHistoryActive ? 'btn-secondary' : 'btn-outline btn-secondary'} ${paddingTop}`}
                    onClick={() => void toggleDayHistory()}
                    disabled={dayHistoryLoading}
                >
                    {dayHistoryLoading ? (
                        <span className="loading loading-spinner loading-xs"></span>
                    ) : 'Day History'}
                </button>
            )}
            {!dayHistoryActive && (
                <>
                    <button
                        className={`btn btn-xs ${showSafeZones ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                        onClick={() => historyStore.getState().setShowSafeZones(!showSafeZones)}
                    >
                        Safe Zones
                    </button>
                    {!isMobile && (
                        <button
                            className={`btn btn-xs ${!includeInvalid ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                            onClick={() => historyStore.getState().setIncludeInvalid(!includeInvalid)}
                        >
                            Valid GPS Only
                        </button>
                    )}
                </>
            )}
        </div>
    )
}
